/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react'
import { PullToRefresh } from 'antd-mobile'
import { PullToRefreshProps as _PullToRefreshProps } from 'antd-mobile/cjs/components/pull-to-refresh'

import loadingBlack from './images/black-cat.gif'
import loadingWhite from './images/white-cat.gif'
import { sniff } from '@/util'
export const BlackCatIcon = <><img src={loadingBlack}
    style={{ width: '40px', height: '40px' }} /></>

export const WhiteCatIcon = <><img src={loadingWhite}
    style={{ width: '40px', height: '40px' }} /></>

export type PullToRefreshProps = Partial<_PullToRefreshProps> & {
  theme?: 'dark' | 'light'
  otherPullToRefreshProps?: PullToRefreshProps
}

const PullToRefresh_ = (props: PullToRefreshProps) => {
  const { theme='dark', disabled = !sniff.isUboxApp, ...otherPullToRefreshProps } = props

  return <PullToRefresh
      disabled={disabled}
      headHeight={80}
      renderText={(e)=>{
        if (e === 'complete' || e === 'pulling' || e === 'canRelease' || e === 'refreshing' ) {
          return theme=='dark' ? BlackCatIcon : WhiteCatIcon
        }
      }}
      threshold={60}
      {...otherPullToRefreshProps}>
    {props.children}
  </PullToRefresh>
}

export default PullToRefresh_